var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9983 0H17.8553C19.0388 0 19.9982 0.959379 19.9982 2.14284V14.9999C19.9982 16.1833 19.0388 17.1427 17.8553 17.1427C17.4608 17.1427 17.141 16.8229 17.141 16.4284C17.141 16.0339 17.4608 15.7141 17.8553 15.7141C18.2498 15.7141 18.5696 15.3943 18.5696 14.9998V2.14284C18.5696 1.74834 18.2498 1.42854 17.8553 1.42854H4.9983C4.60381 1.42854 4.28401 1.74834 4.28401 2.14284C4.28401 2.53733 3.96426 2.85713 3.56976 2.85713C3.17526 2.85713 2.85547 2.53733 2.85547 2.14284C2.85547 0.959379 3.81485 0 4.9983 0ZM2.14284 3.57119H14.2856C15.469 3.57119 16.4284 4.53057 16.4284 5.71403V17.8567C16.4284 19.0402 15.469 19.9996 14.2856 19.9996H2.14284C0.959379 19.9996 0 19.0402 0 17.8567V5.71403C0 4.53057 0.959379 3.57119 2.14284 3.57119ZM14.2856 18.5711C14.6801 18.5711 14.9998 18.2513 14.9998 17.8568V5.71403C14.9998 5.31953 14.6801 4.99974 14.2856 4.99974H2.14284C1.74834 4.99974 1.42854 5.31953 1.42854 5.71403V17.8568C1.42854 18.2513 1.74834 18.5711 2.14284 18.5711H14.2856Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.cd2674dbf68d47b862b330b596e2ee4f.svg";
export { ForwardRef as ReactComponent };